import messages from './messages.json';

type lang = 'en' | 'ja';
type keys = keyof typeof messages[lang];

export type i18nKeys = keys;

export function i18n(name: keys, data?: {}) {
  const lang = document.documentElement.lang as lang;
  const message: {
    [name in keys]: string;
  } = messages[lang];
  const f = new Function('return `' + message[name] + '`');
  return f.call(data);
}
